import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal"
import luckyWinnerRewardsModel from "@/models/lucky-winner/lucky-winner-rewards"
import router from "@/router"
import store from "@/store"
import useFlatPickr from "@/utils/hooks/useFlatPickr"
import {
  getCurrentInstance,
  onBeforeMount,
  reactive,
  ref,
} from "@vue/composition-api"

export default function useRoundInfo() {
  const { createRewards, editRewards, fetchRewardsListByCampaign, fetchRewardsListByRound, createDuplicateRewards } = luckyWinnerRewardsModel()
  const vm = getCurrentInstance().proxy

  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
  } = useValidationModal()

  const {
    validFrom,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr()

  const rewardInfoData = reactive({
    seq: 0,
    name: null,
    value: null,
    status: false,
  })

  const campaignSeq = ref(null)
  const roundSeq = ref(null)

  const isEdit = ref(false)

  const fetchRewardInfoFunc = () => {
    // loading.tableData = true
    // fetchRoundList.payload.CampaignId = campaignId.value
    // fetchRoundList.payload.Page = pagination.currentPage
    // fetchRoundList.payload.Limit = pagination.perPage
    // fetchRoundList.payload.Filters = filters
    // store
      // .dispatch('api/apiRequest', fetchRoundList)
      // .then(response => {
        // if(response.status == "success") {
          rewardInfoData.seq = 1
          rewardInfoData.name = "รางวัลบัตรเงินสด True Money"
          rewardInfoData.value = 5000
          rewardInfoData.status = false
    //     }
    // })
    // .catch(error => {
    //   openDefaultErrorModal(error)
    // })
    // .finally(() => {
    //   loading.tableData = false
    // })
  }

  const checkFormCreateOrEdit = () => {
    isEdit.value = false
    if (router.currentRoute.params.rewardId) {
      isEdit.value = true
      rewardInfoData.seq = router.currentRoute.params.rewardId
    }
  }

  const onNumberInput = (ev, dataValue) => {
    vm.$nextTick(() => {
      const inputNumber = ev.replace(/\D/g, "")
      rewardInfoData[dataValue] = inputNumber
    })
  }

  const onSubmitForm = () => {
    window.$loading(true)
    const payload = {
      CampaignId: "",
      RoundId: null,
      RewardsName: "",
      Amount: 0,
      Ref: "",
      Status: false
    }

    createRewards.payload = payload
    editRewards.payload = payload

    let payloadParam = {}
    if (isEdit.value == true) {
      payloadParam = editRewards
      payloadParam.payload.Id = rewardInfoData.seq
      payloadParam.payload.CampaignId = campaignSeq.value
      payloadParam.payload.RoundId = roundSeq.value
      payloadParam.payload.RewardsName = rewardInfoData.name
      payloadParam.payload.Amount = rewardInfoData.value
      payloadParam.payload.Ref = ""
      payloadParam.payload.Status = rewardInfoData.status
    } else {
      payloadParam = createRewards
      payloadParam.payload.CampaignId = campaignSeq.value
      payloadParam.payload.RoundId = roundSeq.value
      payloadParam.payload.RewardsName = rewardInfoData.name
      payloadParam.payload.Amount = rewardInfoData.value
      payloadParam.payload.Ref = ""
      payloadParam.payload.Status = rewardInfoData.status
    }
    store
      .dispatch('api/apiRequest', payloadParam)
      .then(response => {
        if (response.status == "success") {
          router.replace(`/lucky-winner/campaign/${campaignSeq.value}/round/${roundSeq.value}/reward/list`)

          openSuccessModal("ทำรายการสำเร็จ !", null, null, null, () => {
            checkFormCreateOrEdit()
            fetchRewardInfoFunc()
          })
        }
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  onBeforeMount(() => {
    campaignSeq.value = router.currentRoute.params.campaignId
    roundSeq.value = router.currentRoute.params.roundId

    checkFormCreateOrEdit()
    if (rewardInfoData.seq) {
      fetchRewardInfoFunc()
    }
  })

  return {
    campaignSeq,
    roundSeq,
    rewardInfoData,
    validFrom,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    onNumberInput,
    onSubmitForm,
  }
}
